/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
// Material Dashboard 2 React components
import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Delete, Edit, MoreVert } from '@mui/icons-material';
import { Box, Menu, MenuItem, Modal } from '@mui/material';
import { toast } from 'react-toastify';

import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';
import ProgressStatus from 'components/ProgressStatus/ProgressStatus';
import TableTypography from 'components/TableTypography/TableTypography';

import { formatCurrency } from 'helpers/formatData';
import { deleteProperty } from 'services/addProperty.service';

//having components
const BasicPopover = ({
  propertyId,
  fetchPropertiesInfo,
  notFundedProperty,
}) => {
  const navigate = useNavigate();
  const [loadingButton, setLoadingButton] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    closeMenu();
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };
  const [menu, setMenu] = useState(null);
  const openMenu = ({ currentTarget }) => setMenu(currentTarget);
  const closeMenu = () => setMenu(null);
  // handle edit
  const editProperty = () => {
    closeMenu();
    navigate(`/properties/${propertyId}`, {
      replace: true,
    });
  };
  //delete property api integration
  const handleDeleteProperty = async (id) => {
    setLoadingButton(true);
    try {
      const res = await deleteProperty(id);
      if (!res.isError) {
        handleClose();
        toast.success(res?.message);
        fetchPropertiesInfo();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
    setLoadingButton(false);
  };
  return (
    <div>
      <MoreVert
        variant="contained"
        onClick={openMenu}
        style={{ cursor: 'pointer' }}
      />
      <Menu
        id="simple-menu"
        anchorEl={menu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={Boolean(menu)}
        onClose={closeMenu}
      >
        <MenuItem onClick={(e) => editProperty(e)}>
          <Edit style={{ marginRight: '4px' }} /> Edit Property
        </MenuItem>
        {notFundedProperty && (
          <MenuItem onClick={handleOpen}>
            <Delete color="error" style={{ marginRight: '4px' }} /> Delete
            Property
          </MenuItem>
        )}
      </Menu>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <MDTypography id="modal-modal-title" variant="h4" component="h2">
            Are you sure you want to delete this property?
          </MDTypography>
          <MDBox align="right" marginTop="32px">
            <MDButton
              color="error"
              onClick={() => handleDeleteProperty(propertyId)}
              isLoading={loadingButton}
              disabled={loadingButton}
            >
              Yes, delete
            </MDButton>
            <MDButton onClick={handleClose}>No, cancel</MDButton>
          </MDBox>
        </Box>
      </Modal>
    </div>
  );
};

export const columns = [
  {
    Header: 'actions',
    accessor: 'actions',
    align: 'center',
    disableSortBy: true,
  },
  { Header: 'Name', accessor: 'name', align: 'left', disableSortBy: true },
  {
    Header: 'Address',
    accessor: 'address',
    align: 'center',
    disableSortBy: true,
  },
  {
    Header: 'Type',
    accessor: 'propertyType',
    align: 'left',
    disableSortBy: true,
  },
  {
    Header: 'Status',
    accessor: 'propertyStatus',
    align: 'center',
    disableSortBy: true,
  },
  {
    Header: 'Price',
    accessor: 'propertyPrice',
    align: 'center',
    disableSortBy: true,
  },
  {
    Header: 'Funded Percentage',
    accessor: 'fundedPercentage',
    align: 'center',
    disableSortBy: true,
  },
  {
    Header: 'Total Share',
    accessor: 'totalShare',
    align: 'center',
    disableSortBy: true,
  },
  {
    Header: 'Total Investment',
    accessor: 'amountInvested',
    align: 'center',
    disableSortBy: true,
  },
  {
    Header: 'Last Dividend per Share',
    accessor: 'lastDividend',
    align: 'right',
    disableSortBy: true,
  },
  {
    Header: 'Last Traded Price',
    accessor: 'lastTraded',
    align: 'right',
    disableSortBy: true,
  },
  {
    Header: 'Reg D',
    accessor: 'isRegD',
    align: 'right',
    disableSortBy: true
  },
];

const PropertyName = ({ propertyName, propertyId, isDrafted }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/properties/${propertyId}`);
  };
  return (
    <div onClick={handleClick} style={{ cursor: 'pointer' }}>
      {propertyName}
      {isDrafted && <span style={{ color: 'red' }}>{' (Drafted)'}</span>}
    </div>
  );
};

export const getPropertyStatus = (val) => {
  switch (val) {
    case 'rentReady':
      return 'Rent Ready';
    case 'rented':
      return 'Rented';
    case 'marketedForRent':
      return 'Market For Rent';
    default:
      return '-';
  }
};

export const rows = (propertiesList, fetchPropertiesInfo) =>
  propertiesList.properties?.map((rowData) => {
    return {
      ...rowData,
      name: (
        <PropertyName
          propertyName={rowData.name}
          propertyId={rowData.id}
          isDrafted={rowData.isDrafted}
        />
      ),
      propertyStatus: getPropertyStatus(rowData.propertyStatus),
      address: rowData.address || '-',
      propertyType: rowData.propertyType.name,
      fundedPercentage: (
        <ProgressStatus value={rowData?.fundedPercentage ?? 0} />
      ),
      propertyPrice: (
        <TableTypography value={formatCurrency(rowData?.propertyPrice)} />
      ),
      amountInvested: (
        <TableTypography value={(rowData?.amountInvested || rowData?.amountInvested === 0) ? formatCurrency(rowData?.amountInvested) : 'NA'} />
      ),
      lastDividend: (
        <TableTypography value={rowData?.lastDividendPerShare ?? 'NA'} />
      ),
      lastTraded: <TableTypography value={rowData?.lastTradePrice ?? 'NA'} />,
      isRegD: <TableTypography value={String(rowData?.isRegD) === 'true' ? "Yes" : 'No' ?? 'NA'} />,
      actions: (
        <BasicPopover
          propertyId={rowData.id}
          fetchPropertiesInfo={fetchPropertiesInfo}
          notFundedProperty={!Boolean(Number(rowData?.fundedPercentage))}
        />
      ),
    };
  });
